/**
 * Verbatim disclaimer copy for the Income/Rent verification modals AND the
 * react-pdf verification report (both import these). Income copy matches
 * Figma 5598:36684 (STEP4-DESIGN-SPEC §13).
 */

export interface VerificationDisclaimer {
	heading: string
	/** Smaller second heading line (rent disclaimers carry one). */
	subHeading?: string
	sup?: string
	body: string
}

const AI_ANALYSIS_NOTICE: VerificationDisclaimer = {
	heading: 'AI Analysis Notice',
	body: "This report is automated analysis of the applicant's banking transactions that the applicant provided. TrueTenant does not guarantee accuracy or completeness and does not verify transactions with financial institutions or employers.",
}

export const INCOME_DISCLAIMERS: VerificationDisclaimer[] = [
	{
		heading: 'Average Monthly Deposits',
		body: "The average of the categories selected above. Verified Income Pattern and Government Benefits are on by default; TrueTenant receives up to 12 months of banking history. The average uses only the months this applicant's connection returned.",
	},
	{
		heading: 'Verified Income',
		body: "These deposits meet TrueTenant's threshold for a verified income pattern, based on automated review of the applicant's banking history provided by the applicant. No automated analysis is certain. TrueTenant verifies the pattern, not the employment behind it: employers are not contacted, and employment status, tenure, and source of funds are not confirmed. Treat this as a strong indicator rather than proof, and confirm directly where it matters.",
	},
	{
		heading: 'Government Benefits',
		body: "Recurring payments TrueTenant's analysis identifies as coming from a federal, provincial, or municipal benefit program. Included in Average Monthly Deposits by default. Treat this as a strong indicator rather than proof, and confirm directly where it matters.",
	},
	{
		heading: 'Side Gig Income',
		body: 'Deposits TrueTenant identifies as supplemental earned income. Treat this as a strong indicator rather than proof, and confirm directly where it matters.',
	},
	{
		heading: 'Deposits Potentially Related to Income',
		body: 'These deposits resemble income but follow no clear recurring pattern. Treat this as a strong indicator rather than proof, and confirm directly where it matters.',
	},
	AI_ANALYSIS_NOTICE,
]

export const RENT_DISCLAIMERS: VerificationDisclaimer[] = [
	{
		heading: 'Strong Match',
		body: "These transactions meet TrueTenant's threshold for a strong rent match, based on automated review of the applicant's banking history provided by the applicant. No automated analysis is certain. TrueTenant verifies the pattern, not the landlord or lease behind it. Treat this as a strong indicator rather than proof, and confirm directly where it matters.",
	},
	{
		heading: 'Possible Match',
		body: 'These transactions resemble rent payments but do not meet the strong-match threshold. They may represent rent or unrelated activity. Treat this as a strong indicator rather than proof, and confirm directly where it matters.',
	},
	{
		heading: 'AI Analysis Notice',
		body: 'This report is an automated analysis of up to 12 months of banking history the applicant provided. TrueTenant does not guarantee accuracy or completeness and does not verify transactions with financial institutions or landlords.',
	},
]
